import { Track } from "@/src/lib/tracking";
import { MessageParser } from "./types";

/**
 * JSON 消息解析器
 * 通用的 JSON 格式消息解析
 */
export class JSONMessageParser implements MessageParser {
  parse(data: string | ArrayBuffer | Blob): any | null {
    try {
      let messageStr: string;

      if (data instanceof ArrayBuffer) {
        messageStr = new TextDecoder().decode(data);
      } else if (data instanceof Blob) {
        Track.log("warn", "JSONMessageParser", "Blob 类型暂不支持同步解析");
        return null;
      } else {
        messageStr = data;
      }

      return JSON.parse(messageStr);
    } catch (error) {
      Track.error(error, { tag: "JSONMessageParser", msg: "JSON 解析错误:" });
      return null;
    }
  }

  serialize(message: any): string {
    if (typeof message === "string") {
      // 如果已经是字符串,尝试验证是否是有效的 JSON
      try {
        JSON.parse(message);
        return message;
      } catch {
        // 不是有效的 JSON,则作为普通字符串包装
        return JSON.stringify(message);
      }
    }
    return JSON.stringify(message);
  }
}
